import { render, staticRenderFns } from "./SessionEdit.vue?vue&type=template&id=2841e5a6&scoped=true"
import script from "./SessionEdit.vue?vue&type=script&lang=js"
export * from "./SessionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841e5a6",
  null
  
)

export default component.exports